<template>
  <router-link :to="to" class="nav-link" v-bind="$attrs">
    <slot />
  </router-link>
</template>

<script>
export default {
  name: "AppNavLink",
  props: {
    to: {
      type: [String, Object],
      required: true,
    },
  },
};
</script>
